enum ActionTypes {
  FETCH_EXTERNAL_DEVICES_REQUEST = 'FETCH_EXTERNAL_DEVICES_REQUEST',
  FETCH_EXTERNAL_DEVICES_SUCCESS = 'FETCH_EXTERNAL_DEVICES_SUCCESS',
  FETCH_EXTERNAL_DEVICES_FAILURE = 'FETCH_EXTERNAL_DEVICES_FAILURE'
}

export default ActionTypes;